const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export const isLocalQuoteTestMode = () =>
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined" &&
  LOCAL_HOSTS.has(window.location.hostname);
